import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useQuery } from '~~utils/CommonUtils';
import { TABLET_WIDTH } from '~~elements/Const';

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  .league-header {
    &--pic {
      border-radius: 50%;
      width: 6rem;
      height: 6rem;
      margin-right: 0.5rem;
      object-fit: cover;
    }
    &--name {
      font-size: 1.2rem;
    }
    &--change {
      color: #aaaaaa;
      display: flex;
      align-items: center;
      font-size: 0.8rem;

      select,
      option {
        color: #aaaaaa;
        &:hover,
        &:focus {
          display: inline-block;
        }
      }

      &-hint {
        font-size: 0.8rem;
        margin-left: 3rem;
      }
      select {
        display: none;
      }

      &:hover,
      &:focus {
        select {
          display: inline-block;
        }
      }
    }
  }

  @media (max-width: ${TABLET_WIDTH}) {
    flex-direction: column;
    text-align: center;
    align-items: center;
    .league-header {
      &--change-hint {
        margin-left: 0;
      }
    }
  }
`;

const LeagueHeader = ({ leagues, leagueIndex, setLeagueIndex }) => {
  const query = useQuery();
  useEffect(() => {
    const lindex = query.get('lindex');
    const queryLeagueIndex = parseInt(lindex);
    if (!lindex || queryLeagueIndex === leagueIndex) {
      if (!leagues[leagueIndex]) {
        query.delete('lindex');
        setLeagueIndex(0);
        return;
      }
      return;
    }

    if (Number.isNaN(queryLeagueIndex) || queryLeagueIndex < 0 || queryLeagueIndex > leagues.length - 1) {
      return query.delete('lindex');
    }

    setLeagueIndex(queryLeagueIndex);
  }, [leagueIndex, leagues, query, setLeagueIndex]);

  const handleLeagueChange = (e) => {
    query.set({ lindex: e.target.value });
  };

  if (leagues.length === 0) {
    return <></>;
  }

  return (
    <StyledDiv>
      <img className="league-header--pic" src={leagues[leagueIndex]?.info.logo_url} alt="" />
      <div>
        <div className="league-header--name">
          <a
            href={`${process.env.REACT_APP_MAINPAGE_URL}/league/${leagues[leagueIndex]?.info.uniqid}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {leagues[leagueIndex]?.info.name}
          </a>
        </div>
      </div>
      {leagues.length > 1 && (
        <label className="league-header--change" tabIndex="-1">
          <div className="league-header--change-hint">切換</div>
          <select value={leagueIndex} onChange={handleLeagueChange}>
            {leagues.map((league, index) => (
              <option key={index} value={index}>
                {league.info.name}
              </option>
            ))}
          </select>
        </label>
      )}
    </StyledDiv>
  );
};

export default LeagueHeader;
